import { render, staticRenderFns } from "./SectionItemForm.vue?vue&type=template&id=4e1ed7e1&"
import script from "./SectionItemForm.vue?vue&type=script&lang=js&"
export * from "./SectionItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports